export const environment = {
  walletProvider: 'hutko' as 'hutko' | 'stripe',
  production: false,
  cognito: {
    userPoolId: 'us-east-1_4P6Aoxl3n',
    clientId: '45gnr52mt33445n35vjfcamjsq',
    authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_4P6Aoxl3n',
    // Hosted UI domain (Cognito domain, no protocol)
    domain: 'auth.api.dev.intsurfing.com',
  },
  // App redirect URIs configured in Cognito Hosted UI
  redirectUrl: 'https://platform.api.dev.intsurfing.com',
  redirectSignOutUrl: 'https://platform.api.dev.intsurfing.com',
  // Backend API base for Account Manager (used to ensure user after SSO)
  accountManagerApiBaseUrl: 'https://server.api.dev.intsurfing.com',
  stripePublishableKey:
    'pk_test_51U0jVeIAmKfFG2qYH3PsHYAli1lpXUrBC6XcclWpiWxndi9jyjfQgrVgRAz6c2toz9ljQvL0dLbChbSBy462Qg0n00J6MsKCBg',
  // Google reCAPTCHA v3 site key (to be provided per environment)
  recaptcha: {
    siteKey: '6Leu0X8sAAAAAEbjGxuyd6aQTecXXt5i9RnoJgLm',
  },
  gtmId: 'GTM-TC8BZ2XN',
};
